import { TabsContent } from "ui";

import {
  type NavigationPartProps,
  type NavigationTabsContextValue,
} from "./NavigationTabs";

export function createNavigationTabsContent(
  useNavigationContext: () => NavigationTabsContextValue,
) {
  return function NavigationTabsContent(props: NavigationPartProps) {
    const ctx = useNavigationContext();

    return (
      <TabsContent value={ctx.getCurrentTabId()} className={props.className}>
        {props.children}
      </TabsContent>
    );
  };
}
